
<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="javascript:void(0)">Hot Game Management</a>
      <div class="collapse navbar-collapse">
          <button class="btn btn-sm btn-outline-primary ms-auto" (click)="manageHotGame()">Manage Hot Game</button>
      </div>
    </div>
</nav>
<hr/>
<div class="row">
    <app-tablev2 #table></app-tablev2>
</div>